import { render, staticRenderFns } from "./PassoDadosFalecimento.vue?vue&type=template&id=324e355a&"
import script from "./PassoDadosFalecimento.vue?vue&type=script&lang=js&"
export * from "./PassoDadosFalecimento.vue?vue&type=script&lang=js&"
import style0 from "./PassoDadosFalecimento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports